import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * djb2 hash → unsigned 32-bit → base36
 * Produces consistent 4–6 char strings for typical inputs.
 */
export function hashString(str: string) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    // hash * 33 + str.charCodeAt(i)
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
  }
  // >>> 0: force unsigned 32-bit, then base36 for compactness
  return (hash >>> 0).toString(36);
}
